<template>
  <div class="elite-tabs-wrapper-content">
    <div class="title-header">
      <div class="row">
        <div class="col-6">
          <h3>{{ tax.name }}</h3>
          <badge v-if="tax.active" type="success">
            {{ $t("TAXES.ACTIVE") }}
          </badge>
          <badge v-else type="secondary">
            {{ $t("TAXES.DEACTIVATED") }}
          </badge>
        </div>

        <div class="col-6 text-right">
          <base-button
            class="elite-button btn-outline-danger"
            icon
            size="sm"
            v-if="$currentUserCan($permissions.PERM_DELETE_TAXES)"
            @click="deleteTax"
          >
            <span class="btn-inner--icon">
              <i class="far fa-trash-alt"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.DELETE") }}
            </span>
          </base-button>

          <base-button
            class="elite-button add"
            icon
            size="sm"
            v-if="$currentUserCan($permissions.PERM_EDIT_TAXES)"
            @click="editTax"
          >
            <span class="btn-inner--icon">
              <i class="far fa-edit"></i>
            </span>
            <span class="btn-inner--text">
              {{ $t("COMMON.EDIT") }}
            </span>
          </base-button>
        </div>
      </div>
    </div>

    <div class="all-infos">
      <div class="all-infos-text">
        <dl class="row" v-if="tax.organization">
          <dt>{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd>
            {{ tax.organization.name ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.name">
          <dt>{{ $t("COMMON.NAME") }}</dt>
          <dd>
            {{ tax.name ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.label">
          <dt>{{ $t("TAXES.DENOMINATION") }}</dt>
          <dd>
            {{ tax.label ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.tax_number">
          <dt>{{ $t("TAXES.TAX_NUMBER") }}</dt>
          <dd>
            {{ tax.tax_number ?? "" }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.tax_type">
          <dt>{{ $t("TAXES.TRANSACTION") }}</dt>
          <dd>
            {{ $t("TAXES." + tax?.tax_type) }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.calculation_base">
          <dt>{{ $t("TAXES.CALCULATION_BASE") }}</dt>
          <dd>
            {{ $t("TAXES." + tax?.calculation_base) }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.calculation_type == TYPE_MONTANT_FIXE">
          <dt>{{ $t("TAXES.AMOUNT") }}</dt>
          <dd>
            {{ $formatCurrency(tax.value) }}
          </dd>
        </dl>

        <dl class="row" v-if="tax.calculation_type == TYPE_POURCENTAGE">
          <dt>{{ $t("TAXES.PERCENTAGE") }}</dt>
          <dd>{{ tax.value }} %</dd>
        </dl>

        <dl class="row" v-if="tax.excerpt">
          <dt>{{ $t("COMMON.EXCERPT") }}</dt>
          <dd>
            {{ tax.excerpt ?? "" }}
          </dd>
        </dl>

        <dl class="row">
          <dt>{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd>
            {{ $timeZoneDateFormat(tax.created_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt>{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd>
            {{ $timeZoneDateFormat(tax.updated_at) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_POURCENTAGE, TYPE_MONTANT_FIXE } from "@/constants/taxes";
export default {
  name: "tax-view-global",
  components: {},
  props: ["tax"],

  data() {
    return {
      TYPE_MONTANT_FIXE: TYPE_MONTANT_FIXE,
      TYPE_POURCENTAGE: TYPE_POURCENTAGE,
    };
  },

  methods: {
    editTax() {
      this.$emit("onEditTax", this.tax);
    },
    deleteTax() {
      this.$emit("onDeleteTax", this.tax);
    },
  },
};
</script>
